import config from 'config';
import { useEffect, useState } from 'react';
import { UserTypeEnum } from 'types/enums/User';
import { useAuth } from 'utils/auth';

const useTokenClaims = () => {
  const { getIdTokenClaims } = useAuth();
  const [userType, setUserType] = useState<UserTypeEnum>();
  const [returnToUrl, setReturnToUrl] = useState('');
  const [signUpApp, setSignUpApp] = useState('');
  const [signUpPartnerGuest, setSignUpPartnerGuest] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getIdTokenClaims().then(data => {
      if (!data) {
        setIsLoading(false);
        return;
      }
      setUserType(
        data[`${config.claimsNamespace}/signUpUserType`]?.toUpperCase() ??
          UserTypeEnum.PARTNER
      );
      setReturnToUrl(data[`${config.claimsNamespace}/returnToUrl`]);
      setSignUpPartnerGuest(
        data[`${config.claimsNamespace}/signUpPartnerGuest`]
      );
      setSignUpApp(data[`${config.claimsNamespace}/signUpApp`]);
      setIsLoading(false);
    });
  }, [getIdTokenClaims]);

  return {
    isLoading,
    userType,
    isPartner: userType === UserTypeEnum.PARTNER,
    isConsumer: userType === UserTypeEnum.CONSUMER,
    returnToUrl,
    signUpApp,
    signUpPartnerGuest,
  };
};

export default useTokenClaims;
